import { pick, uniqBy } from 'lodash-es';

import { DATA_TYPE } from '../configs/constants';
import { appStore } from '../../../utils/helpers';

export const redirectToReportsAndExports = (searchParams = '') => {
  const redirectURL = new URL(`/my_reports${searchParams}#exports`, window.location.origin);
  window.location.assign(redirectURL.href);
};

const prepareEntities = (entities) =>
  entities.map((entity) => ({
    ...pick(entity, 'ref_no', 'kind', 'value'),
    ...(entity.store && { store: appStore(entity.store) }),
    kind: entity?.kind?.replace('unified_', ''),
  }));

export const decorateUpsertExportRequestParams = (report, appendParams = {}) => {
  const { id, ...restReport } = report;

  let exportRequestData = {
    ...restReport,
    entities: prepareEntities(report.entities),
    ...appendParams,
  };

  if (report.data_type === DATA_TYPE.MPI) {
    exportRequestData = {
      ...exportRequestData,
      mpi_data_points: uniqBy(
        [...restReport.mpi_data_points, ...report.entities.map((e) => e.mpi)],
        'id'
      ),
      entities: prepareEntities(report.entities.filter((entity) => entity.has_mpi)),
    };
  }

  return {
    custom_export: exportRequestData,
  };
};
